import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { CREATE_OUTLET, CREATE_OUTLET_ERROR, CREATE_OUTLET_SUCCESS } from '../../actions.js';

function* createOutlet({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/digital/outlets`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_OUTLET_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);

      yield put({
        type: CREATE_OUTLET_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_OUTLET_ERROR, payload: error });
  }
}

export function* watchCreateOutlet() {
  yield takeEvery(CREATE_OUTLET, createOutlet);
}

function* createOutletSaga() {
  yield all([fork(watchCreateOutlet)]);
}

export default createOutletSaga;
